var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { JsonObject, JsonProperty } from "json2typescript";
import { PositionModel } from "@core/models/positions/position.model";
import { MomentConverter } from "@core/serializer/moment-convertor";
let JobTemplateModel = class JobTemplateModel {
    constructor() {
        this.id = -1;
        this.alias_position = "";
        this.hasJobPostPermission = false;
        this.hasEditPostPermission = false;
        this.title = "";
        this.post_type = POST_TYPES.BOTH;
        this.created = undefined;
    }
};
__decorate([
    JsonProperty("id", Number)
], JobTemplateModel.prototype, "id", void 0);
__decorate([
    JsonProperty("alias_position", String, true)
], JobTemplateModel.prototype, "alias_position", void 0);
__decorate([
    JsonProperty("hasJobPostPermission", Boolean, true)
], JobTemplateModel.prototype, "hasJobPostPermission", void 0);
__decorate([
    JsonProperty("hasEditPostPermission", Boolean, true)
], JobTemplateModel.prototype, "hasEditPostPermission", void 0);
__decorate([
    JsonProperty("title", String, true)
], JobTemplateModel.prototype, "title", void 0);
__decorate([
    JsonProperty("post_type", String, true)
], JobTemplateModel.prototype, "post_type", void 0);
__decorate([
    JsonProperty("created", MomentConverter.getConverter('ISO_DATETIME'), true)
], JobTemplateModel.prototype, "created", void 0);
JobTemplateModel = __decorate([
    JsonObject("JobTemplateModel")
], JobTemplateModel);
export { JobTemplateModel };
let JobPositionTemplateModel = class JobPositionTemplateModel {
    constructor() {
        this.position = new PositionModel();
        this.templates = [];
    }
};
__decorate([
    JsonProperty("position", PositionModel)
], JobPositionTemplateModel.prototype, "position", void 0);
__decorate([
    JsonProperty("templates", [JobTemplateModel])
], JobPositionTemplateModel.prototype, "templates", void 0);
JobPositionTemplateModel = __decorate([
    JsonObject("JobPositionTemplateModel")
], JobPositionTemplateModel);
export { JobPositionTemplateModel };
let BrandJobTemplatesModel = class BrandJobTemplatesModel {
    constructor() {
        this.inherited_templates = [];
        this.templates = [];
    }
};
__decorate([
    JsonProperty("inherited_templates", [JobPositionTemplateModel])
], BrandJobTemplatesModel.prototype, "inherited_templates", void 0);
__decorate([
    JsonProperty("templates", [JobPositionTemplateModel])
], BrandJobTemplatesModel.prototype, "templates", void 0);
BrandJobTemplatesModel = __decorate([
    JsonObject("BrandJobTemplatesModel")
], BrandJobTemplatesModel);
export { BrandJobTemplatesModel };
export var POST_TYPES;
(function (POST_TYPES) {
    POST_TYPES["PUBLIC"] = "PUBLIC";
    POST_TYPES["PRIVATE"] = "PRIVATE";
    POST_TYPES["BOTH"] = "BOTH";
})(POST_TYPES || (POST_TYPES = {}));
//# sourceMappingURL=job-template.model.js.map